import { isValidId, toIdString } from './ids.js';

export function readValue(source, ...keys) {
  for (const key of keys) {
    const value = source?.[key];
    if (value !== undefined && value !== null) return value;
  }
  return '';
}

export function readNumberOrNull(source, ...keys) {
  const value = readValue(source, ...keys);
  if (value === '' || value === null || value === undefined) return null;
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : null;
}

export function normalizeCartItem(item) {
  return {
    itemId: toIdString(readValue(item, 'itemId', 'ItemId', 'productId', 'ProductId', 'id', 'Id')),
    quantity: Number(readValue(item, 'quantity', 'Quantity', 'qty', 'Qty')) || 0,
    price: Number(readValue(item, 'price', 'Price', 'rate', 'Rate')) || 0,
  };
}

/**
 * Produces the exact body POST /api/v1/Order/place binds. Every key emitted here matches a
 * property on the server's CheckoutRequest - a name the server does not know is dropped in
 * silence, with no validation error, so callers may pass their own aliases but this function's
 * output must not drift.
 */
export function normalizePlaceOrderPayload(payload = {}) {
  const user = readValue(payload, 'user', 'User') || {};
  const sourceItems =
    readValue(payload, 'cartItems', 'CartItems') ||
    readValue(payload, 'items', 'Items') ||
    [];

  return {
    userId: toIdString(readValue(payload, 'userId', 'UserId')),
    user: {
      firstName: String(readValue(user, 'firstName', 'FirstName') || ''),
      secondName: String(readValue(user, 'secondName', 'SecondName') || ''),
      lastName: String(readValue(user, 'lastName', 'LastName') || ''),
      mobile: String(readValue(user, 'mobile', 'Mobile') || ''),
      email: String(readValue(user, 'email', 'Email') || ''),
      address1: String(readValue(user, 'address1', 'Address1') || ''),
      address2: String(readValue(user, 'address2', 'Address2') || ''),
      city: String(readValue(user, 'city', 'City') || ''),
      country: String(readValue(user, 'country', 'Country') || ''),
    },
    payment: String(readValue(payload, 'payment', 'Payment') || ''),
    mobileNumber: String(readValue(payload, 'mobileNumber', 'MobileNumber') || ''),
    zaadMobile: String(readValue(payload, 'zaadMobile', 'ZaadMobile') || ''),
    edahabMobile: String(readValue(payload, 'edahabMobile', 'EdahabMobile') || ''),
    currency: String(readValue(payload, 'currency', 'Currency', 'edahabCurrency', 'EdahabCurrency') || ''),
    checkoutIdempotencyKey: String(
      readValue(payload, 'checkoutIdempotencyKey', 'CheckoutIdempotencyKey', 'idempotencyKey', 'IdempotencyKey') || ''
    ),
    latitude: readNumberOrNull(payload, 'latitude', 'Latitude'),
    longitude: readNumberOrNull(payload, 'longitude', 'Longitude'),
    locationAccuracy: readNumberOrNull(payload, 'locationAccuracy', 'LocationAccuracy'),
    locationAddress: String(readValue(payload, 'locationAddress', 'LocationAddress') || ''),
    locationCity: String(readValue(payload, 'locationCity', 'LocationCity') || ''),
    locationSource: String(readValue(payload, 'locationSource', 'LocationSource') || ''),
    cartItems: (Array.isArray(sourceItems) ? sourceItems : [])
      .map(normalizeCartItem)
      .filter((item) => isValidId(item.itemId) && item.quantity > 0),
  };
}
